import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/rem';

  .IBTreeTable {
    background: white;
    border-radius: 16px;
    overflow-x: auto;
  }

  .IBTreeTable__wrapper {
    min-width: 1100px;
  }

  .IBTreeTable__Header-Row,
  .IBTreeTable__Row {
    display: grid;
    grid-template-columns: 44px 1.5fr 1.2fr 1fr 1fr 1fr 1.7fr 1.2fr 1fr 1.5fr 1fr;
    grid-auto-rows: minmax(56px, auto);
    gap: 2px;
    word-break: break-word;
    align-items: center;
  }

  .IBTreeTable__Header-Row {
    border-bottom: 1px solid #f3f3f3;
    padding: 0 8px;
  }

  .IBTreeTable__Header-Cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px 4px;
    font-size: 12px;
    color: #999;
    font-weight: 400;
  }

  .IBTreeTable__Header-Top {
    font-size: 13px;
    color: #333;
    font-weight: 500;
    margin-bottom: 2px;
  }

  .IBTreeTable__Row {
    cursor: pointer;
    padding: 0 8px;
    transition: background 0.15s;
  }

  .IBTreeTable__Row:not(:last-child) {
    border-bottom: 1px solid #f3f3f3;
  }

  .IBTreeTable__Row--ib {
    background: #f5e6c8;
    font-weight: 500;
  }

  .IBTreeTable__Row--ib:hover {
    background: #edd9a8;
  }

  .IBTreeTable__Row--user:hover {
    background: #fafafa;
  }

  .IBTreeTable__Cell {
    display: flex;
    align-items: center;
    padding: 4px;
    font-size: 14px;
    color: #333;
    min-height: 56px;
  }

  .IBTreeTable__Cell--checkbox {
    justify-content: center;
  }

  .IBTreeTable__Cell--name {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .IBTreeTable__Cell--ib-name {
    cursor: pointer;
  }

  .IBTreeTable__IBNameWrapper {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
  }

  .IBTreeTable__ExpandIcon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  .IBTreeTable__ExpandIcon--placeholder {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    display: inline-block;
  }

  .IBTreeTable__IBLabel {
    font-size: 11px;
    color: #999;
    font-weight: 400;
  }

  .IBTreeTable__IBName {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .IBTreeTable__Children {
    animation: ib-fade-in 0.2s forwards;
    opacity: 0;
  }

  @keyframes ib-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .IBTreeTable__pagination {
    padding: 8px 16px;
  }
`;

export { staticStyles };
